export const getComplementParams = (url, defaultParams, paramsSend) => {
  const serviceUrl = url?.split('?')?.[0];
  const paramsFromUrl = new URLSearchParams(url?.split('?')?.[1]);
  const complementParams = {};
  paramsFromUrl.forEach((value, key) => {
    if (key === 'api_version' && value !== defaultParams?.[key]) {
      complementParams[key] = value;
    }
    if (!defaultParams[key]) {
      complementParams[key] = value;
    }
  });

  const allParams = { ...complementParams, ...defaultParams };
  for (let paramKey in paramsSend) {
    if (
      paramKey === 'api_version' &&
      paramsSend?.[paramKey] !== defaultParams?.[paramKey]
    ) {
      complementParams[paramKey] = paramsSend[paramKey];
    }
    if (!allParams[paramKey]) {
      complementParams[paramKey] = paramsSend[paramKey];
    }
  }
  const allQueryParams = {"params": complementParams}

  return {
    allQueryParams,
    serviceUrl,
  };
};
